import { render, staticRenderFns } from "./cardPay.vue?vue&type=template&id=3faf05e2&scoped=true"
import script from "./cardPay.vue?vue&type=script&lang=js"
export * from "./cardPay.vue?vue&type=script&lang=js"
import style0 from "./cardPay.vue?vue&type=style&index=0&id=3faf05e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf05e2",
  null
  
)

export default component.exports